const T = require("react").PropTypes;

const CompleteReport = {
    PropType: T.shape({
        AuditCount: T.array,
        AuditPeriod: T.string,
        AuditTypeName: T.string,
        Districts: T.array,
        Division: T.string,
        StoreCount: T.array,
        NinetyDayCount: T.array
    })
};

module.exports = CompleteReport; 


// WEBPACK FOOTER //
// ./src/types/CompleteReport.js